<app-annuity-dialog
  [templateMode]="true"
  [compareTemplate]="true"
  (compareTemplateData)="addTemplateData($event)"
></app-annuity-dialog>
